/**
 * The design pipeline's stages, in customer-facing language.
 *
 * Single source of truth: the loading screen (DesignProgress) and the bottom
 * bar both read from here, so the two can never show different wording for the
 * same stage. Keys must match the `apiRunStatus` values the backend writes in
 * estimateController's run-automation handler.
 */
export const DESIGN_STAGES = [
  { key: 'ai_roof', label: 'Analyzing your roof' },
  { key: 'designing', label: 'Placing your panels' },
  { key: 'irradiance', label: 'Mapping sun exposure' },
  { key: 'simulating', label: 'Calculating production' },
];

/** Index of a stage key, or -1 when unknown/absent. */
export const stageIndex = (key) => DESIGN_STAGES.findIndex((s) => s.key === key);

/**
 * Customer-facing label for a stage key. Falls back to a neutral message when
 * the run hasn't reported a stage yet (or reports one we don't know), so the
 * UI never shows a raw key like `ai_roof`.
 */
export const stageLabel = (key, fallback = 'Building your design…') => {
  const stage = DESIGN_STAGES.find((s) => s.key === key);
  return stage ? stage.label : fallback;
};
